import { Controller } from "@hotwired/stimulus"

// Generyczny POST do `url-value` z X-CSRF-Token; po sukcesie emituje event `remote-action:success`.
// Reakcję na sukces (ukrycie elementu, refresh frame'a itd.) podpinasz przez `data-action`,
// np. `remote-action:success->simple-hide#hide`.
export default class extends Controller {
  static values = { url: String }

  post(event) {
    event?.preventDefault()
    const csrfToken = document.querySelector("meta[name=csrf-token]")?.content

    fetch(this.urlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": csrfToken },
    }).then((response) => {
      if (response.ok) this.dispatch("success")
      else this.dispatch("error")
    }).catch(() => {
      this.dispatch("error")
    })
  }
}
